import PupilsRepository from '@api/repositories/organization-pupil-repository'
import { IOrganizationPupils } from '@app/interfaces/pupil/organization-pupils'
import ModalFooter from '@app/shared/modal-footer/modal-footer'
import { openNotificationWithIcon } from '@app/shared/notification/notification'
import { refreshOrganizationPupils } from '@app/store/actions/organization-pupils-actions'
import { Button, Form, Input, Modal, Spin } from 'antd'
import { AxiosResponse } from 'axios'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'

interface props {
  pupil: IOrganizationPupils
}

const OrganizationPupilsQueueDismiss: React.FC<props> = ({ pupil }) => {
  const [confirmLoading, setConfirmLoading] = useState<boolean>(false)
  const [form] = Form.useForm()
  const [t] = useTranslation()
  const dispatch = useDispatch()
  const [visible, setVisible] = useState<boolean>(false)

  const showModal = () => {
    setVisible(true)
  }

  const hideModal = () => {
    setVisible(false)
  }

  const onFinish = async (values: any) => {
    const newValues = {
      id: pupil.id,
      orderNo: values.orderNo,
      note: values.note,
    }
    setConfirmLoading(true)
    const userSubmitApi = PupilsRepository.dismiss

    await userSubmitApi(newValues)
      .then((response: AxiosResponse<IOrganizationPupils>) => {
        if (response.status === 200) {
          dispatch(refreshOrganizationPupils())
          openNotificationWithIcon('success', t('pupils.dismissed'))
          setConfirmLoading(false)
        }
      })
      .catch(() => {
        setConfirmLoading(false)
      })
    if (!confirmLoading) {
      hideModal()
    }
    setConfirmLoading(false)
  }

  function getActualDate() {
    const date = new Date()
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const day = date.getDate()
    return day + '.' + month + '.' + year
  }

  const date = getActualDate()

  return (
    <React.Fragment>
      <Button
        onClick={showModal}
        type="link"
        style={{ width: '100%', height: '100%' }}
      >
        {t('pupils.dismiss')}
      </Button>
      <Modal
        open={visible}
        title={t('pupils.dismiss')}
        confirmLoading={confirmLoading}
        destroyOnClose={true}
        onCancel={hideModal}
        footer={[
          <React.Fragment key={1}>
            <ModalFooter
              confirm={confirmLoading}
              onCancel={hideModal}
              onSubmit={form.submit}
            />
          </React.Fragment>,
        ]}
      >
        <Spin spinning={confirmLoading}>
          <Form
            form={form}
            onFinish={onFinish}
            initialValues={{}}
            layout={'vertical'}
          >
            <Form.Item hidden={true} name={'id'} initialValue={pupil.pupilId}>
              <Input />
            </Form.Item>
            <Form.Item
              label={t('pupils.orderNo')}
              name={'orderNo'}
              rules={[
                {
                  transform: (value) =>
                    typeof value === 'string' ? value.trim() : undefined,
                  required: true,
                  message: t('errors.requiredMessage'),
                },
              ]}
            >
              <Input disabled={confirmLoading} />
            </Form.Item>
            <Form.Item
              label={t('pupils.note')}
              name={'note'}
              rules={[
                {
                  transform: (value) =>
                    typeof value === 'string' ? value.trim() : undefined,
                  required: true,
                  message: t('errors.requiredMessage'),
                },
              ]}
            >
              <Input disabled={confirmLoading} />
            </Form.Item>
            <Form.Item
              initialValue={date}
              name={'orderDate'}
              label={t('pupils.orderDate')}
            >
              <Input disabled={true} />
            </Form.Item>
          </Form>
        </Spin>
      </Modal>
    </React.Fragment>
  )
}

export default OrganizationPupilsQueueDismiss
